import type { CreateBranchType } from '@readme/api/src/mappings/version/types';

/**
 * Returns an empty `Version` object that's used when creating a new version.
 */
export function createDefaultVersion<Keys extends CreateBranchType>(keys: Partial<Keys> = {}) {
  return {
    base: '',
    display_name: '',
    i18n: {
      lang: '',
      parsed_version: '',
    },
    name: '',
    privacy: { view: 'hidden' },
    release_stage: 'release',
    state: 'current',
    ...keys,
  } satisfies CreateBranchType;
}
